import { twMerge } from "tailwind-merge";
import { useChat } from "../../context/ChatContext";
import { EmpreenderApps } from "../../lib/AppsArray";
import { useSubMenu } from "../../SubMenuContext";
import { Button } from "../Button";

const Suggestions = ({inline = false}: {inline?: boolean}) => {
    const { app } = useSubMenu();
    const { handleSubmit, isStreaming } = useChat();
    

    const matchApp = EmpreenderApps.find((a) =>
        a.tags.some((tag) => tag?.toLowerCase() === app?.toLowerCase())
    );

    if (!matchApp) return null;

    const handlePerguntaClick = async (pergunta: string) => {
        if(isStreaming) return;
        await handleSubmit(pergunta);
    };

    return (
        <>
            <div className="flex flex-row items-center">
                <div
                    className={twMerge('w-full flex flex-row items-center overflow-x-auto overflow-y-hidden custom-scroll zero-scroll no-smooth gap-1', `${inline ? 'flex-nowrap' : 'flex-wrap justify-center'}`)}
                    onWheel={(e) => {
                        e.currentTarget.scrollLeft += e.deltaY;
                    }}>
                    {matchApp?.perguntasFrequentes?.map((pergunta) => (
                        <Button
                            disabled={isStreaming}
                            key={pergunta}
                            onClick={() => handlePerguntaClick(pergunta)}
                            variant="outline"
                            className="!text-[11px] whitespace-nowrap rounded-full">
                            {pergunta}
                        </Button>
                    ))}
                </div>
            </div>
        </>
    );
};

export default Suggestions;